import { File, FileAudio, FileSpreadsheet, FileText, Image as ImageIcon, Presentation, Video } from 'lucide-react'

/** Shared file-type glyphs and colours used by Drive and attachment previews. */
export function getFileVisual(mime: string) {
  if (mime.startsWith('image/')) return { Icon: ImageIcon, color: '#7c3aed', bg: '#ede9fe' } // incl. PNG / PSD
  if (mime.startsWith('video/')) return { Icon: Video, color: '#db2777', bg: '#fce7f3' } // mp4/mov/m4v/3gp
  if (mime.startsWith('audio/')) return { Icon: FileAudio, color: '#d97706', bg: '#fef3c7' } // mp3/m4a/caf/ogg
  if (mime === 'application/pdf') return { Icon: File, color: '#dc2626', bg: '#fee2e2' } // plain page (≠ text doc), red
  // Plain text before the generic text/* → word branch below (same glyph, distinct colour).
  if (mime === 'text/plain') return { Icon: FileText, color: '#0891b2', bg: '#cffafe' }
  if (mime.includes('spreadsheet') || mime.includes('excel') || mime.includes('csv'))
    return { Icon: FileSpreadsheet, color: '#059669', bg: '#d1fae5' }
  if (mime.includes('presentation') || mime.includes('powerpoint'))
    return { Icon: Presentation, color: '#ea580c', bg: '#ffedd5' }
  if (mime.includes('word') || mime.startsWith('text/')) return { Icon: FileText, color: '#2563eb', bg: '#dbeafe' } // doc glyph, blue

  return { Icon: File, color: '#475569', bg: '#e2e8f0' }
}
